<template>
  <!-- NOTE (TEMPLATE) to show the active proposals -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/researcher/goingPc'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-activeProposals) to show the active proposals list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedItems"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="هنوز طرحی ثبت نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div
            v-if="data.item.status == 'پذیرش علمی-در انتظار ادمین'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-warning p-2" disabled
              >پذیرش علمی-در انتظار ادمین</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'درحال انجام'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-yahoo p-2" disabled
              >درحال انجام</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'اتمام'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-success p-2" disabled
              >اتمام</b-button
            >
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <a
              v-if="
                data.item.requestType == 'طرح پژوهشی' &&
                data.item.status != 'پذیرش علمی-در انتظار ادمین'
              "
              style="width: 100%"
              :href="'/researcher/proposalCp/' + data.item.id"
              target="_blank"
              class="btn btn-primary text-light"
              >جزییات</a
            >
            <a
              v-if="
                data.item.requestType == 'پسادکتری' &&
                data.item.status != 'پذیرش علمی-در انتظار ادمین'
              "
              style="width: 100%"
              :href="'/researcher/postDocCp/' + data.item.id"
              target="_blank"
              class="btn btn-primary text-light"
              >جزییات</a
            >
            <a
              v-if="
                data.item.requestType == 'نخبگان وظیفه' &&
                data.item.status != 'پذیرش علمی-در انتظار ادمین'
              "
              style="width: 100%"
              :href="'/researcher/EliteCp/' + data.item.id"
              target="_blank"
              class="btn btn-primary text-light"
              >جزییات</a
            >
            <a
              v-if="
                data.item.requestType == 'نشست تخصصی' &&
                data.item.status != 'پذیرش علمی-در انتظار ادمین'
              "
              style="width: 100%"
              :href="'/researcher/meetingCp/' + data.item.id"
              target="_blank"
              class="btn btn-primary text-light"
              >جزییات</a
            >
            <a
              v-if="
                data.item.requestType == 'فرصت مطالعاتی' &&
                data.item.status != 'پذیرش علمی-در انتظار ادمین'
              "
              style="width: 100%"
              :href="'/researcher/opportunityCp/' + data.item.id"
              target="_blank"
              class="btn btn-primary text-light"
              >جزییات</a
            >
            <a
              v-if="
                data.item.requestType == 'مقاله' &&
                data.item.status != 'پذیرش علمی-در انتظار ادمین'
              "
              style="width: 100%"
              :href="'/researcher/articleCp/' + data.item.id"
              target="_blank"
              class="btn btn-primary text-light"
              >جزییات</a
            >
            <a
              v-if="
                data.item.requestType == 'رساله دکتری' &&
                data.item.status != 'پذیرش علمی-در انتظار ادمین'
              "
              style="width: 100%"
              :href="'/researcher/phdProposalCp/' + data.item.id"
              target="_blank"
              class="btn btn-primary text-light"
              >جزییات</a
            >
            <a
              v-if="
                data.item.requestType == 'پایان نامه کارشناسی ارشد' &&
                data.item.status != 'پذیرش علمی-در انتظار ادمین'
              "
              style="width: 100%"
              :href="'/researcher/masterProposalCp/' + data.item.id"
              target="_blank"
              class="btn btn-primary text-light"
              >جزییات</a
            >
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "projectCode", label: "کد طرح" },
        { key: "requestType", label: "نوع حمایت" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "lastUpdate", label: "آخرین بروزرسانی" },
        { key: "operation", label: "عملیات" },
      ],
      items: [],
      filter: "",
      isBusy: true,
    };
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      // NOTE (MOUNTED) to show the proposals data
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/pcs/ongoing",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.$bvModal.hide("loading");
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },
  computed: {
    computedItems() {
      if (this.items) {
        return this.items.sort((a, b) => {
          if (a.time < b.time) {
            return 1;
          }
          if (a.time > b.time) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
  },
  mounted() {
    this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
